module.exports = __webpack_public_path__ + "img/image.f6c10d67.svg";